import { useState } from "react";
import { Link } from "react-router-dom";

const links = [
  { href: "/#home", label: "Giới thiệu" },
  { href: "/#tools", label: "Công cụ" },
  { href: "/#skills", label: "Kỹ năng" },
  { href: "/#contact", label: "Liên hệ" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="pt-0">
      <nav className={`site-nav ${open ? "is-open" : ""}`}>
        <Link to="/" className="font-extrabold text-lg tracking-tight mr-auto">
          NHẬT DUY<span className="text-[#79a9ff]">.</span>
        </Link>

        <div className="hidden md:flex items-center gap-6 text-sm text-gray-400">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="hover:text-white transition-colors">
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="/#tools"
          className="hidden md:inline-block px-3 py-2 rounded-lg text-sm bg-white/[0.03] border border-white/[0.05]"
        >
          Xem công cụ
        </a>

        <button
          type="button"
          aria-label="Mở menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2"
        >
          <span
            className={`block w-[23px] h-[2px] bg-gray-200 rounded-full transition-transform mb-[5px] ${
              open ? "translate-y-[7px] rotate-45" : ""
            }`}
          />
          <span className={`block w-[23px] h-[2px] bg-gray-200 rounded-full mb-[5px] ${open ? "opacity-0" : ""}`} />
          <span
            className={`block w-[23px] h-[2px] bg-gray-200 rounded-full transition-transform ${
              open ? "-translate-y-[7px] -rotate-45" : ""
            }`}
          />
        </button>

        {open && (
          <div className="md:hidden absolute top-[72px] left-0 right-0 flex flex-col gap-1 p-2 rounded-2xl border border-white/10 bg-[#09172af7] backdrop-blur-xl shadow-2xl">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 rounded-lg text-sm text-gray-300 hover:bg-white/[0.05] hover:text-white"
              >
                {l.label}
              </a>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}
